import { render, staticRenderFns } from "./salesGoods.vue?vue&type=template&id=f14b3d06&scoped=true"
import script from "./salesGoods.vue?vue&type=script&lang=js"
export * from "./salesGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14b3d06",
  null
  
)

export default component.exports